export default "__VITE_ASSET__Ehg$Oq7B__"